import {connect} from 'react-redux';

import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
} from '../../../../libs/shared/core/src/services/tracking/tracking';
import {CalendarsPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {
  makeGetFindIsCalendarVersionImporting,
  makeGetFindIsCalendarVersionSelected,
  makeGetSortedCalendarVersions,
} from '../../../store/data/calendarsList/calendarsListSelectors';
import {updateCalendarVersionAction} from '../../../store/data/calendarVersions/calendarVersionsActions';
import {getFindCalendarVersionName} from '../../../store/data/calendarVersions/calendarVersionsSelectors';
import {getCalendarVersions} from '../../../store/data/dataSelectors';
import {
  toggleSelectedCalendarVersionAction,
  unselectCalendarVersionAction,
  updateViewingNowCalendarsAction,
} from '../../../store/panels/calendars/calendarsPanelActions';
import {
  makeGetCalendarsPanel,
  makeGetSelectedCalendarVersionIds,
  makeGetViewingNowCalendars,
} from '../../../store/panels/calendars/calendarsPanelSelectors';
import {ViewingNowCalendar} from '../../../store/panels/calendars/calendarsPanelState';
import {CalendarsList} from './calendarsList';

/*
 * Props.
 */

interface CalendarsListContainerProps {
  panelId: CalendarsPanelId;
  shouldSaveCalendarVersion: boolean;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CalendarsListContainerProps>()(() => {
  const getSelectedCalendarVersionIds = makeGetSelectedCalendarVersionIds();
  const getFindIsCalendarVersionImporting = makeGetFindIsCalendarVersionImporting();
  const getFindIsCalendarVersionSelected = makeGetFindIsCalendarVersionSelected(
    getSelectedCalendarVersionIds,
  );
  const getSortedCalendarVersions = makeGetSortedCalendarVersions(getFindIsCalendarVersionSelected);

  const getCalendarsPanel = makeGetCalendarsPanel();
  const getViewingNowCalendars = makeGetViewingNowCalendars(getCalendarsPanel);

  return {
    sortedCalendarVersions: getSortedCalendarVersions,
    findIsCalendarVersionImporting: getFindIsCalendarVersionImporting,
    findIsCalendarVersionSelected: getFindIsCalendarVersionSelected,
    findCalendarVersionName: getFindCalendarVersionName,
    viewingNowCalendars: getViewingNowCalendars,
    calendarVersions: getCalendarVersions,
  };
});

const mapDispatchToProps = makeMapDispatchToProps<CalendarsListContainerProps>()(
  ({panelId, shouldSaveCalendarVersion}) => ({
    onCalendarVersionClick: (calendarVersionId: number) =>
      toggleSelectedCalendarVersionAction(panelId, calendarVersionId, shouldSaveCalendarVersion),
    onViewingNowCalendarsChange: (viewingNowCalendars: ReadonlyArray<ViewingNowCalendar>) =>
      updateViewingNowCalendarsAction(panelId, viewingNowCalendars),

    onAddCalendarClick: (calendarVersionId: number) => {
      trackInterfaceEvent(InterfaceEventsEnum.ADD_CALENDAR_TO_LIST);
      return updateCalendarVersionAction(calendarVersionId, {isHidden: false});
    },
    onRemoveCalendarClick: (calendarVersionId: number) =>
      updateCalendarVersionAction(calendarVersionId, {isHidden: true}),
    unselectCalendarVersion: (calendarVersionId: number) =>
      unselectCalendarVersionAction(panelId, calendarVersionId, shouldSaveCalendarVersion),
  }),
);

export const CalendarsListContainer = connect(mapStateToProps, mapDispatchToProps)(CalendarsList);
